import React, { useCallback, useState } from 'react';
import { TransformWrapper } from 'react-zoom-pan-pinch';

import { ImageViewerContent } from './image-viewer-content';
import {
  ButtonFactoryFn,
  ImageViewerData,
  ImageViewerInfoComponent,
} from './types';

export interface ImageViewerProps<T, K = undefined> {
  allData: ImageViewerData<T>[];
  InfoComponent?: ImageViewerInfoComponent<T, K>;
  defaultIndex?: number;
  minHeight?: number;
  toolbarButtons?: (JSX.Element | ButtonFactoryFn<T>)[];
  autofocus?: boolean;
  customProps?: K;
}

export const ImageViewer = <T, K>({
  allData,
  InfoComponent,
  defaultIndex,
  toolbarButtons,
  minHeight,
  autofocus = false,
  customProps,
}: ImageViewerProps<T, K>) => {
  const [isPanning, setIsPanning] = useState(false);

  const onPanningStart = useCallback(() => setIsPanning(true), []);
  const onPanningStop = useCallback(() => setIsPanning(false), []);

  return (
    <TransformWrapper
      onPanningStart={onPanningStart}
      onPanningStop={onPanningStop}
    >
      <ImageViewerContent
        allData={allData}
        isPanning={isPanning}
        InfoComponent={InfoComponent}
        defaultIndex={defaultIndex}
        toolbarButtons={toolbarButtons}
        minHeight={minHeight}
        autofocus={autofocus}
        customProps={customProps}
      />
    </TransformWrapper>
  );
};
